import React, { useState } from 'react';
import { EditOutlined } from '@ant-design/icons';
import { transparentize } from 'polished';
import { specialFilterColors } from '@utils/colorPalette';
import { ALL_TRAFFIC } from '@utils/constants';
import { tid } from '@utils/test';
import {
  EditFilterButton,
  PrimaryFilterWrapper,
  StyledPrimaryEllipsisTooltip,
  StyledTag,
  VerticalBar,
} from './styled';
import { FilterStatus } from '../FilterDropdown/FilterStatus';
import { useAtom } from 'jotai';
import { primaryFilterVisibilityAtom } from '@src/components/metrics-panel-hz/atoms';

function PrimaryFilterTag({ filterName, onEdit, appliedFilter }) {
  const [showSeries, setShowSeries] = useAtom(primaryFilterVisibilityAtom);

  const filterColor: any = specialFilterColors.get(ALL_TRAFFIC);

  const handleClick = () => {
    setShowSeries(!showSeries);
  };

  const handleEdit = (event) => {
    event.stopPropagation();
    onEdit();
  };

  return (
    <PrimaryFilterWrapper>
      <StyledTag
        onClick={handleClick}
        key={filterName}
        closable={false}
        highlight={showSeries ? transparentize(0.75, filterColor) : '#f2f2f2'}
        style={{ padding: '3px 3px 3px 8px' }}
      >
        <VerticalBar color={filterColor} />
        <StyledPrimaryEllipsisTooltip tooltipText={filterName}>
          <FilterStatus filterName={filterName} appliedFilter={appliedFilter} />
        </StyledPrimaryEllipsisTooltip>
      </StyledTag>
      <EditFilterButton
        type="text"
        icon={<EditOutlined />}
        onClick={handleEdit}
        {...tid('trends-open-filter-popup')}
      />
    </PrimaryFilterWrapper>
  );
}

export default PrimaryFilterTag;
